import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, flatMap } from 'lodash';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import PropertiesTableHeader from '../properties_table_header';
import PropertyRow from '../property_row';

import { getDuplicatePropertiesGroups } from '../../store/selectors/duplicates';
import { getSelectedPropertyIds } from '../../store/selectors/select_list';

export class DuplicatesTable extends React.Component {
  static propTypes = {
    duplicateGroups: PropTypes.arrayOf(PropTypes.shape({
      properties: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired
      })).isRequired
    })).isRequired,
    selectedPropertyIds: PropTypes.arrayOf(PropTypes.number).isRequired
  };

  isSelected(propertyId) {
    return this.props.selectedPropertyIds.indexOf(propertyId) > -1;
  }

  render() {
    return (
      <div className="table-container border-top-0 border-start-0 border-end-0 h-100">
        <SelectableRecordTable
          columnHeaders={<PropertiesTableHeader allowSort={false} />}
          hasSelectAll={false}
        >
          {this.renderProperties()}
        </SelectableRecordTable>
      </div>
    );
  }

  renderProperties() {
    const { duplicateGroups } = this.props;

    return flatMap(duplicateGroups, group => (
      map(group.properties, (property) => {
        return (
          <PropertyRow
            key={property.id}
            property={property}
            selected={this.isSelected(property.id)}
          />
        );
      })
    ));
  }
}

const mapStateToProps = state => ({
  duplicateGroups: getDuplicatePropertiesGroups(state),
  selectedPropertyIds: getSelectedPropertyIds(state)
});

export default connect(mapStateToProps)(DuplicatesTable);
